<template>
    <div id="list-reel-equipment-component" class="pa-4">
        <in-progress-component/>
    </div>
</template>

<script>
import InProgressComponent from "@/components/Error/InProgressComponent";

export default {
    name: "ListReelEquipmentComponent",
    components: {InProgressComponent}
}
</script>